import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { List } from "immutable";
import { Subscription } from "rxjs";
import { ListItem } from "../../../../../../shared/list/list-item";
import { EmrDetailInfoService } from "../emr-detail-info/emr-detail-info.service";
import { EmrDetailAccessInfoService } from "./emr-detail-access-info.service";

@Component({
  selector: "retrieval-emr-detail-access-info",
  templateUrl: "./emr-detail-access-info.component.html",
  styleUrls: ["./emr-detail-access-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmrDetailAccessInfoComponent implements OnInit {

  summaryItems = List<ListItem>();
  retrievalId: number;
  subscription: Subscription;

  constructor(
    private service: EmrDetailAccessInfoService,
    private emrDetailservice: EmrDetailInfoService,
    private changeDetector: ChangeDetectorRef
  ) {

    this.retrievalId = this.service.getEmrGdFromPath();

  }

  ngOnInit() {
    this.emrDetailservice
      .getSummaryItems()
      .subscribe(items => this.summaryItems = this.assignAndNotify(items));

    this.subscription = this.emrDetailservice.reset
      .subscribe(id => {
        this.updatesummary(id);
      });

  }

  updatesummary(id) {
    this.emrDetailservice
      .getSummaryItems()
      .subscribe(items => this.summaryItems = this.assignAndNotify(items));
  }

  private assignAndNotify<T>(data: T[]): List<T> {
    this.changeDetector.markForCheck();
    const dataList = List(data);

    return dataList;
  }

}
